import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportInventoriesFilters, getReportInventoriesAction } from "redux/actions/Reports/reportInventories/reportInventoriesActions";

export const ReportInventoriesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportInventories }) => reportInventories);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInventoriesAction({ startDate, endDate, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInventoriesAction({ startDate, endDate, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte de inventario días" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingReportInventories ? <LoadingComponent /> :
        <TableInputs
          reducer="reportInventories"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportInventoriesFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
